import React, { useContext } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Box from "@amzn/meridian/box";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Icon from "@amzn/meridian/icon";

const FAView = (props) => {
  const { viewModel } = useContext(OverviewContext);

  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-fph">
          <Heading level={3} type="h300" alignment="left">
            <FormattedMessage
              id={viewModel.fa[props.fa.processName].title}
              defaultMessage={viewModel.fa[props.fa.processName].defaultMessage}
            />
            <Tooltip
              position="right"
              title={props.intl.formatMessage({
                id: viewModel.fa[props.fa.processName].tooltip,
                defaultMessage:
                  viewModel.fa[props.fa.processName].tooltipMessage,
              })}
            >
              <Icon className={"custom-tool-tip"} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>

        <Text type="d50">{"95%"}</Text>
      </div>
    </Box>
  );
};

export default injectIntl(FAView);



// WEBPACK FOOTER //
// ./src/components/WIP/FAView.js